module.exports = __webpack_public_path__ + "img/alexander.e784232f.jpeg";